<script setup lang="ts">
import imgClose from '@/assets/Fill 1@2x.png'
import AssignNameTipHost from '@/views/Home/components/AssignNameTipHost.vue'

defineProps<{
  headerTitle: string
  embedded: boolean
}>()

const emit = defineEmits<{
  close: []
}>()
</script>

<template>
  <header class="schedule-header" :class="{ 'schedule-header--embedded': embedded }">
    <AssignNameTipHost v-if="embedded" :text="headerTitle" class="schedule-title-tip-host">
      <h1 class="schedule-title">{{ headerTitle }}</h1>
    </AssignNameTipHost>
    <h1 v-else class="schedule-title">{{ headerTitle }}</h1>
    <button type="button" class="schedule-close" aria-label="Close" @click="emit('close')">
      <img :src="imgClose" class="schedule-close-ic" alt="" />
    </button>
  </header>
</template>

<style scoped>
.schedule-header.schedule-header--embedded {
  flex: 0 0 72px;
  width: 100%;
  min-width: 0;
  height: 72px;
  min-height: 72px;
  max-height: 72px;
  padding: 0 24px 0 16px;
  background: #ffffff;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
  overflow: hidden;
  align-items: center;
}

.schedule-header--embedded .schedule-title-tip-host {
  flex: 1;
  min-width: 0;
}

.schedule-header--embedded .schedule-title {
  margin: 0;
  padding: 0;
  width: 100%;
  min-width: 0;
  font-family: SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.schedule-header--embedded .schedule-close {
  flex-shrink: 0;
  align-self: center;
  margin: 0;
}

.schedule-header {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px 16px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

.schedule-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  line-height: 1.35;
  max-width: calc(100% - 48px);
}

.schedule-close {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 6px;
}

.schedule-close-ic {
  width: 14px;
  height: 14px;
  display: block;
  object-fit: contain;
}
</style>
